import { datadogRum } from '@datadog/browser-rum';

export const logError = (error: Error | unknown, errProps: AnyObject): void => {
  datadogRum.addError(error, errProps);
};
